/**
 * PHARMAKON — Refonte Achats · Stock : saisie d'une facture d'achat, browser twin of the server CONFIG.
 *
 * The S1 entry screen (/achats/nouveau, refonte WP-22) checks a line before it reaches the server
 * with exactly the bounds the server validator applies, and offers exactly the values it accepts.
 *
 * Owner of the values: `apps/server/src/config/achat-saisie.config.js` (`LIMITES_SAISIE_ACHAT`,
 * `TYPE_ACHAT_VALUES` — the Prisma enum `TypeAchat`), `apps/server/src/config/constants.js`
 * (`TVA_VALID_RATES`) and `apps/server/src/config/achat-prix-suggestion.config.js` (the WP-65 price
 * suggestion sources). This file is a twin, not an import, because the API image is built from
 * apps/server alone; the server test `src/__tests__/achat-saisie.parity.test.js` imports both and
 * fails on any drift — change a value there first, then here.
 */

/** D-14 — the eight « Type d'achat » values, in the Prisma enum order. */
export const TYPE_ACHAT_VALUES = Object.freeze([
  "MEDICAMENT",
  "PARAPHARMACIE",
  "COSMETIQUE",
  "CONSOMMABLE",
  "MATERIEL_MEDICAL",
  "COMPLEMENT_ALIMENTAIRE",
  "ORTHOPEDIE",
  "MIXTE",
]);

/** The legal TVA rates of a purchase line (%). */
export const TAUX_TVA_ACHAT = Object.freeze([0, 9, 19]);

/** The bounds of a facture d'achat entry (validator `achat.validator.js`). */
export const LIMITES_SAISIE_ACHAT = Object.freeze({
  QUANTITE_MAX: 50_000,
  PRIX_ACHAT_HT_MAX: 500_000,
  PRIX_VENTE_PPA_MAX: 100_000,
  LIGNES_MAX: 200,
  NUMERO_MAX: 100,
  NOTES_MAX: 1000,
});

/**
 * Refonte WP-65 (D-27, A-105) — where the PU HT S1 suggests comes from (`GET /achats/prix-suggeres`):
 * the selected fournisseur's last purchase, the latest one from anyone else, none.
 */
export const SOURCE_PRIX_SUGGERE = Object.freeze({
  FOURNISSEUR: "FOURNISSEUR",
  DERNIER_CONNU: "DERNIER_CONNU",
  AUCUN: "AUCUN",
});

/** Where the PPA S1 suggests comes from: the product, its latest purchase line, none (A-105). */
export const SOURCE_PPA_SUGGERE = Object.freeze({
  PRODUIT: "PRODUIT",
  DERNIER_ACHAT: "DERNIER_ACHAT",
  AUCUN: "AUCUN",
});
